import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface DataTableWrapperProps {
  children: React.ReactNode;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
  totalItems?: number;
  itemsPerPage?: number;
  showPagination?: boolean;
}

export function DataTableWrapper({
  children,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  totalItems,
  itemsPerPage,
  showPagination = true,
}: DataTableWrapperProps) {
  const startItem = totalItems ? (currentPage - 1) * (itemsPerPage || 0) + 1 : 0;
  const endItem = totalItems ? Math.min(currentPage * (itemsPerPage || 0), totalItems) : 0;

  return (
    <div className="flex flex-col">
      {/* Scrollable table container */}
      <div className="overflow-x-auto border rounded-md">
        {children}
      </div>

      {/* Sticky pagination footer */}
      {showPagination && (
        <div className="flex items-center justify-between border-t bg-background px-4 py-3 mt-4 rounded-b-md">
          <div className="text-sm text-muted-foreground">
            {totalItems !== undefined && itemsPerPage !== undefined ? (
              <>
                Showing {startItem} to {endItem} of {totalItems} results
              </>
            ) : (
              <>
                Page {currentPage} of {totalPages}
              </>
            )}
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onPageChange?.(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <ChevronLeft className="h-4 w-4 mr-1" />
              Previous
            </Button>
            <div className="text-sm font-medium">
              Page {currentPage} of {totalPages}
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onPageChange?.(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
              <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
